<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.CreatePricelistDialog.Headline' | translate : 'Create pricelist' }}" [isLoading]="isLoading">
    <mat-form-field *ngIf="isChild && childGroups && childGroups.length > 0" appearance="outline">
      <mat-label>{{ 'T4.Settings.Pricelist.drpGroup' | translate : 'Group' }}</mat-label>
      <mat-select [(ngModel)]="childId">
        <mat-option [value]="c.Id" *ngFor="let c of childGroups">{{c.Name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="isChild && childLocations && childLocations.length > 0" appearance="outline">
      <mat-label>{{ 'T4.Settings.Pricelist.drpLocation' | translate : 'Location' }}</mat-label>
      <mat-select [(ngModel)]="childId">
        <mat-option [value]="c.Id" *ngFor="let c of childLocations">{{c.Name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'T4.Settings.Pricelist.drpType' | translate : 'Type' }}</mat-label>
      <mat-select [(ngModel)]="type">
        <mat-option [value]="0">{{ 'T4.Settings.Pricelist.optTypeRent' | translate : 'Rent' }}</mat-option>
        <mat-option [value]="2">{{ 'T4.Settings.Pricelist.optTypeAddons' | translate : 'Addons' }}</mat-option>
        <mat-option [value]="1">{{ 'T4.Settings.Pricelist.optTypeSpareParts' | translate : 'Spare parts' }}</mat-option>
      </mat-select>
    </mat-form-field>
  </t4-container>
</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" style="margin: 5px;" (click)="create()">{{ 'T4.Settings.CreatePricelistDialog.cmdCreate' | translate : 'Create' }}</button>
    <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'T4.Settings.CreatePricelistDialog.cmdCancel' | translate : 'Cancel' }}</button>
  </mat-dialog-actions>
